import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box, Button, Container, Divider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { checkoutAddOn } from '../../../../Redux/Models/master';
import { getUserData } from '../../../../Utils/storages';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { formatNumToCurrency } from '../../../../Utils/helpers';

export default function Component({
  classes, error, message,
}) {
  const user = getUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { t } = useTranslation();

  const { openAlert } = useContext(AlertContext);

  const [addon, setAddon] = useState({});

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    if (state) {
      setAddon(state);
    } else {
      navigate(-1);
    }
  }, [state]);

  const buyAddOn = () => {
    dispatch(checkoutAddOn(user.id, {
      addon: addon.id,
    }));
  };

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <Elements.Navigator title={t('storageInfoPage.confirm')} />
        <Container>
          <Box color="#2E3C40" fontSize={12} fontWeight="700" mt={2}>{t('common.item')}</Box>
          <Box display="flex" gap={1} mt={2}>
            <img alt="extra storage" src={Images.OenoStorage} />
            <Box flex={1}>
              <Box color="#586479" fontWeight="600" fontSize={12}>{t('storageInfoPage.extraStorage')}</Box>
              <Box mt={0.5} display="flex" justifyContent="space-between" alignItems="center">
                <Box color="#404852" fontWeight="700" fontSize={14}>
                  {t('storageInfoPage.storages', { count: addon.extra })}
                </Box>
                <Box color="#404852" fontWeight="700" fontSize={14} display="flex" justifyContent="space-between" alignItems="center" gap={0.5}>
                  <img alt="euro" src={Images.Euro} width="14" height="14" />
                  {formatNumToCurrency(Number(addon.price))}
                </Box>
              </Box>
            </Box>
          </Box>
          <Elements.Info
            message={(
              <Box>
                <Box color="#404852" fontWeight="700">
                  {t('storageInfoPage.youWillHave', { count: user.total_quota + addon.extra })}
                </Box>
                <Box color="#586479">
                  {t('storageInfoPage.youWillHaveDesc', { prevCount: user.total_quota, newCount: addon.extra })}
                </Box>
              </Box>
          )}
            alignItems="center"
            mt={2}
            py={1}
          />
        </Container>
        <Divider sx={{ border: '4px solid #F5F6F8', my: 2 }} />
        <Container>
          <Box className="weight-700">{t('storageInfoPage.purchasedDetails')}</Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={1.5}>
            <Box className="s-12 weight-400">{t('storageInfoPage.price')}</Box>
            <Box className="s-12 weight-700">
              {formatNumToCurrency(Number(addon.price))}
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mt={1.5}>
            <Box className="s-12 weight-400">{t('storageInfoPage.tax')}</Box>
            <Box className="s-12 weight-700">FREE</Box>
          </Box>

          <Divider sx={{ border: '1px dashed #F5F6F8', my: 1.5 }} />

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box className="s-12 weight-700">{t('storageInfoPage.totalPay')}</Box>
            <Box className="s-12 weight-700 primary-green">
              {formatNumToCurrency(Number(addon.price))}
            </Box>
          </Box>
        </Container>

        <Divider sx={{ border: '4px solid #F5F6F8', my: 2 }} />

        <Container>
          <Box className="s-12 weight-400">
            {t('common.torConfirm')}
            {' '}
            <Link to={ROUTES.termsConditions()} className="link weight-700 black">{t('common.tor')}</Link>
            {' '}
            &
            {' '}
            <Link to={ROUTES.privacyPolicy()} className="link weight-700 black">{t('common.privacy')}</Link>
            {' '}
            of OenoBank.
          </Box>
        </Container>

        <Box
          border="none"
          sx={{ outline: 'none' }}
          boxShadow="none"
          position="absolute"
          bottom={0}
          left={0}
          right={0}
          py={1}
          px={1.5}
          // bgcolor="white"
        >
          <Button variant="contained" className="btn-contained" fullWidth onClick={buyAddOn}>
            {t('common.order')}
          </Button>
        </Box>
      </div>
    </Elements.PageBase>
  );
}
